<div class="bmd">
  <div class="bmd__header">
    <div class="bmd__title-row">
      <h2 class="bmd__title">Book meeting</h2>
      <button type="button" class="bmd__close" [disabled]="creating" (click)="cancel()" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
          <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
        </svg>
      </button>
    </div>
    @if (relatedRecord) {
      <div class="bmd__subject">
        <span class="bmd__subject-avatar">{{ getRecordInitials() }}</span>
        <span class="bmd__subject-name">{{ getRecordDisplayName() }}</span>
      </div>
    }
  </div>

  <div class="bmd__body">
    <div class="bmd__intro-block">
      <div class="bmd__intro-title">Choose a meeting template for this booking</div>
      <!-- Case 1502: picker Add button is hidden (canCreate defaults to false), so the
          "create a basic template here" line was removed. If creating from the picker
          comes back (likely System Admin only), restore: "You can also create a basic
          template here, but full customization is only available on the scheduling page." -->
      <div class="bmd__intro-helper">To get started, select a meeting template you'd like to use.</div>
    </div>
    <booking-event-picker
      [selectedEvent]="selectedEvent"
      [listAllEvents]="listAllEvents"
      (eventSelected)="onEventSelected($event)"
      (creatingChange)="onPickerCreatingChange($event)">
    </booking-event-picker>
  </div>

  <div class="bmd__footer">
    <button type="button" class="bmd__btn bmd__btn--secondary" [disabled]="creating" (click)="cancel()">Cancel</button>
    <button type="button"
      class="bmd__btn bmd__btn--primary"
      [disabled]="!selectedEvent?._id || creating"
      (click)="continueToBooking()">
      Continue
    </button>
  </div>
</div>